import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  getClientSecretBegin,
  getClientSecretSuccess,
  getClientSecretErr,
  getCustomerCardsBegin,
  getCustomerCardsSuccess,
  getCustomerCardsErr,
  deleteCardBegin,
  deleteCardSuccess,
  deleteCardErr,
  setDefaultCardBegin,
  setDefaultCardSuccess,
  setDefaultCardErr
} = actions;

const getClientSecretAPI = '/admin/get-client-secret';
const getCustomerCardAPI = '/admin/get-customer-cards';
const deleteCustomerCardsAPI = '/admin/delete-customer-card'
const setDefaultCardAPI = '/admin/set-default-card'

const getClientSecret = (values = "") => {
  return async (dispatch) => {
    dispatch(getClientSecretBegin());
    try {
      const response = await DataService.get(getClientSecretAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getClientSecretErr(response?.data?.message));
      } else {
        dispatch(getClientSecretSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getClientSecretErr(err));
    }
  };
};

const getCustomerCards = (values = "") => {
  return async (dispatch) => {
    dispatch(getCustomerCardsBegin());
    try {
      const response = await DataService.get(getCustomerCardAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getCustomerCardsErr(response?.data?.message));
      } else {
        dispatch(getCustomerCardsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getCustomerCardsErr(err));
    }
  };
};

const deleteCard = (values) => {
  return async (dispatch) => {
    dispatch(deleteCardBegin());
    try {
      const response = await DataService.post(deleteCustomerCardsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(deleteCardErr(response?.data?.message));
      } else {
        dispatch(deleteCardSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(deleteCardErr(err));
    }
  };
};

const setDefaultCard = (values) => {
  return async (dispatch) => {
    dispatch(setDefaultCardBegin());
    try {
      const response = await DataService.post(setDefaultCardAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(setDefaultCardErr(response?.data?.message));
      } else {
        dispatch(setDefaultCardSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(setDefaultCardErr(err));
    }
  };
};

export { getClientSecret, getCustomerCards, deleteCard, setDefaultCard };
